import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { IpClientService } from '../services/ip-client.service';

export function setClientListDisabledStatus(status: boolean): CanActivateFn | CanDeactivateFn<any> {
	return () => {
		// Update the status.
		inject(IpClientService).setClientListDisabledStatus(status);
		// We always return true because the setting above returns void
		return true;
	};
}
